// extracted by mini-css-extract-plugin
export var collapse_content = "index-module--collapse_content--ec675";
export var collapse_title = "index-module--collapse_title--68c6b";
export var dropdown_list_container = "index-module--dropdown_list_container--b1978";
export var side_nav_bar_wrapper = "index-module--side_nav_bar_wrapper--37ef3";
export var side_nav_link = "index-module--side_nav_link--dae93";